// Parent Progress tab: concise Homework Tutor session summaries (never the
// full tutoring transcript).
import { useEffect, useState } from "react";
import { NotebookPen } from "lucide-react";
import { api } from "../../lib/api";

export const HomeworkSummaryCard = () => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    api.get("/homework/family/summary")
      .then(({ data }) => setRows(data.summaries || []))
      .catch(() => setRows([]));
  }, []);
  if (!rows.length) return null;
  return (
    <section className="bg-card rounded-2xl border border-border p-5"
      data-testid="homework-summary-card">
      <h2 className="text-base md:text-lg font-bold font-display flex items-center gap-2 mb-3">
        <NotebookPen className="h-5 w-5 text-secondary" aria-hidden="true" />
        Homework Tutor sessions
      </h2>
      <div className="space-y-2">
        {rows.map((s) => (
          <button key={s.hw_id} type="button"
            onClick={() => setOpen(open === s.hw_id ? null : s.hw_id)}
            className="w-full text-left rounded-xl border border-border p-3 hover:border-violet-300"
            data-testid={`hw-summary-${s.hw_id}`}>
            <div className="flex justify-between gap-2 text-sm">
              <span className="font-bold">{s.child_name}: {s.title}</span>
              <span className="text-xs text-muted-foreground shrink-0">{s.date}</span>
            </div>
            <p className="text-xs text-muted-foreground mt-1">
              {s.attempted}/{s.problems} attempted · {s.independent} solo ·{" "}
              {s.with_support} with Pip
            </p>
            {open === s.hw_id && (
              <div className="mt-2 text-xs space-y-1" data-testid={`hw-summary-detail-${s.hw_id}`}>
                {s.skills_practiced.length > 0 && (
                  <p><span className="font-bold">Practiced:</span> {s.skills_practiced.join(", ")}</p>
                )}
                {s.needs_practice.length > 0 && (
                  <p className="text-amber-700">
                    <span className="font-bold">Needs practice:</span> {s.needs_practice.join(", ")}
                  </p>
                )}
                <p className="text-violet-700 font-bold">{s.recommendation}</p>
              </div>
            )}
          </button>
        ))}
      </div>
    </section>
  );
};
